import React from 'react';

export default ({ size = 16, color = '#000' }) => (
  <svg
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
  >
    <path fill={color} d="M864 128l-480 480-224-224-160 160 384 384 640-640z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/Tick.js